// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyANxEOCCW4o6aLTVCECXC7UK7nrCoxYsyE",
  authDomain: "mary-chan.firebaseapp.com",
  projectId: "mary-chan",
  storageBucket: "mary-chan.firebasestorage.app",
  messagingSenderId: "773978717153",
  appId: "1:773978717153:web:11dfc8afd7021a55ecb0a0",
  measurementId: "G-ER36DLFPS9",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
